import { getCookie, setCookie } from './cookie';

export function setUiValue(name : string, value : string ) : void {
    setCookie(name, value, 365);
}

export function getUiValue(name : string) : string | null {
    return getCookie(name);
}

export function getUiValueInt(name : string) : number | null {
    const v = getUiValue(name);
    if (v !== null && v !== undefined) {
        return parseInt(v);
    } else {
        return v;
    }
}
